import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import './style.scss';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { sendQuality, setQuality, setResponse } from 'modules/actions/quality';

const Feedback = () => {

  const dispatch = useDispatch();

  const messageId = useSelector(state => state.quality.messageId);
  const options = useSelector(state => state.quality.options);
  // (3). 마지막으로 클릭한 bot_message 상태값 가져오기.
  const clickedBotMessage = useSelector(state => state.quality.clickedBotMessage);

  const textRef = useRef();
  const feedbackRef = useRef();
  const [params, setParams] = useState({
    sel: '1',
    text: '',
  });
  const [lastClickedIndex, setLastClickedIndex] = useState(null);

  // (4). 모달을 닫을 시, 마지막으로 클릭한 bot_message 의 _chat_opinion 강제 포커싱 로직.
  const closeModalFocus = () => {

    const botElement = document.querySelector(`div[name="${clickedBotMessage}"]`);
    const opinionElement = botElement.querySelectorAll('._chat_opinion')[0]

    if (opinionElement) {
      opinionElement.setAttribute('tabindex', '0');
      opinionElement.focus();
    }
  };

  const closeModal = () => {
    dispatch(disableAllMenu());
    // 4. closeModalFocus() 호출
    closeModalFocus();
  };

  const checkQuality = (value, index) => {
    setParams(prevState => {
      return {
        sel: value,
        text: prevState.text,
      };
    });
    setLastClickedIndex(index);
  };

  useEffect(() => {
    if (feedbackRef.current) {
      feedbackRef.current.focus();
    }
  }, []);

  const confirmEvt = () => {
    // if (params.sel === '' || params.text === '') return false;
    const payload = {
      message_id: messageId,
      in_type: 'quality',
      quality: {
        value: params.sel,
        // ...options[sel - 1],
        comment: textRef.current?.value || '',
      },
    };
    dispatch(sendQuality(payload));
  };

  const setParamsText = () => {
    setParams(prevState => {
      return {
        sel: prevState.sel,
        text: textRef.current?.value || '',
      };
    });
  };

  return (
    <div className="feedback_bg">
      <div className="feedback_area">
        <i
          className="ri-close-line"
          role="button"
          tabIndex={2}
          title="닫기 버튼"
          onClick={closeModal}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              closeModal();
            }
          }}
        />
        <div className="fd_name fd_name_01">사용자 의견 남기기</div>
        <div className="fd_btn_text">답변이 어땠는지 평가해주세요.</div>
        <div>
          {options.map((i, count) => {
            const className = params.sel === i.value ? '_quality_item _sel' : '_quality_item';
            // if (count === options.length - 1) {
            if (count === 0) {
              return (
                <div
                  key={i.value}
                  className={className}
                  role="button"
                  tabIndex={1}
                  onClick={() => checkQuality(i.value, count)}
                  onKeyPress={e => {
                    if (e.key === 'Enter') {
                      checkQuality(i.value, count);
                    }
                  }}
                  ref={feedbackRef}
                >
                  {i.message}
                </div>
              );
            }
            return (
              <div
                key={i.value}
                className={className}
                role="button"
                tabIndex={1}
                onClick={() => checkQuality(i.value, count)}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    checkQuality(i.value, count);
                  }
                }}
              >
                {i.message}
              </div>
            );
          })}
        </div>
        {lastClickedIndex === options.length - 1 && (
          <>
            <div className="fd_btn_text">답변 관련 의견을 남겨주세요.</div>
            <textarea
              title="의견남기기 입력창"
              ref={textRef}
              maxLength="300"
              className="feed_input_textarea"
              onChange={setParamsText}
              placeholder="답변에 대한 의견을 자유롭게 남겨주세요."
              tabIndex={1}
            />
          </>
        )}
        <div
          className={`fd_send_btn ${params.sel === '' || params.text === '' ? '_inactive' : ''}`}
          role="button"
          tabIndex={1}
          onClick={confirmEvt}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              confirmEvt();
            }
          }}
        >
          확인
        </div>
      </div>
    </div>
  );
};

export default Feedback;
